class MFRMarquee {
    constructor( index, element ) {
        this.$index = index;
        this.$element = $( element );

        this.selectors = {
            item: ".marquee-scroller__item"
        }

        this.init()
    }

    init() {
        this.$item = this.$element.find( ".marquee-scroller__item" );
        let width = 0;
        
        this.$item.each( ( index, element ) => {
            width += $( element ).outerWidth( true );
        });

        this.$element.width( width );
    }
}